import { Feed, getPersonFullName } from '@mntn-dev/ui-components'
import { Link } from '../index.ts'
import type { ActivityDetailsProps } from './types.ts'
import { ActivityTrans } from '../activity-trans.tsx'

export const AgreementTermsAccepted = ({
  activity: {
    target,
    title,
    person,
    details: {
      activityType,
      data: { type },
    },
  },
  t,
  onNavigate,
  currentUrl,
}: ActivityDetailsProps<'agreement_terms_accepted'>) =>
  person && (
    <>
      <Feed.Summary>
        <ActivityTrans
          t={t}
          i18nKey={`${activityType}.summary`}
          values={{
            subject: getPersonFullName(person),
            agreementType: t(`${activityType}.agreementType.${type}`),
            object: title,
          }}
        />
      </Feed.Summary>
      <Feed.Annotations>
        <Feed.Tag type="warning">{t(`${activityType}.status`)}</Feed.Tag>
        <Link
          {...{
            target: { name: title, urn: target.urn },
            t,
            onNavigate,
            currentUrl,
          }}
        />
      </Feed.Annotations>
    </>
  )
